export class Dispute {
  constructor({
    companyId = null,
    invoiceId = null,
    customerId = null,
    currency = null,
    disputeReason = null,
    userName = null,
    amount = 0,
    id = null,
    createdAt = null,
    modifiedAt = null,
    settledAt = null,
    action = null,
    localAmount = 0,
    daysInProgress = 0,
    attachments = [],
    customerName = null,
    lastNote = null,
    disputeNote = null,
    ownerId = null,
    customFields = null,
  }) {
    this.companyId = companyId;
    this.invoiceId = invoiceId;
    this.customerId = customerId;
    this.currency = currency;
    this.disputeReason = disputeReason;
    this.userName = userName;
    this.amount = amount;
    this.id = id;
    this.createdAt = createdAt;
    this.modifiedAt = modifiedAt;
    this.settledAt = settledAt;
    this.action = action;
    this.localAmount = localAmount;
    this.daysInProgress = daysInProgress;
    this.attachments = attachments;
    this.customerName = customerName;
    this.lastNote = lastNote;
    this.disputeNote = disputeNote;
    this.ownerId = ownerId;
    this.customFields = customFields;
  }
}
